interface ConnectorItem {
  id: string
  name: string
  /** Path to the logo image shown inside the tab button. Omit for text-only tabs. */
  logoSrc?: string
  /** Path to the full-size screenshot shown in the preview panel. */
  screenshot: string
  linkText: string
  linkHref: string
}

export const connectorsData: ConnectorItem[] = [
  {
    id: 'claude',
    name: 'Claude',
    logoSrc: '/images/connectors/claude-logo.svg',
    screenshot: '/images/connectors/claude-screenshot.webp',
    linkText: 'See Claude connector',
    linkHref: 'https://claude.com/connectors/omni-analytics',
  },
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    logoSrc: '/images/connectors/chatgpt-logo.svg',
    screenshot: '/images/connectors/chatgpt-screenshot.webp',
    linkText: 'See ChatGPT app',
    linkHref:
      'https://chatgpt.com/apps/omni-analytics/asdk_app_694e8b8715108191a49fe2db4398d9e2',
  },
  {
    id: 'cursor',
    name: 'Cursor',
    logoSrc: '/images/connectors/cursor-logo.svg',
    screenshot: '/images/connectors/cursor-screenshot.webp',
    linkText: "Set up Omni's MCP server in Cursor",
    linkHref: 'https://docs.omni.co/ai/mcp/cursor',
  },
  {
    id: 'custom',
    name: 'Custom chatbot',
    logoSrc: '/images/connectors/custom-chatbot.svg',
    screenshot: '/images/connectors/custom-chatbot-screenshot.webp',
    linkText: "Set up Omni's MCP server",
    linkHref: 'https://docs.omni.co/ai/mcp/index',
  },
]
